<template>
  <div class="condition">
    <v-select
      class="filter__operator"
      :items="operators"
      item-text="name"
      v-model="selectedOperator"
      return-object="return-object"
    ></v-select>
    <v-text-field
      class="filter__value text-xs-right"
      v-model="selected.value"
      v-if="selectedOperator &amp;&amp; selectedOperator.needValue"
      counter="counter"
    ></v-text-field>
  </div>
</template>

<script>
import setSelectedOperator from '../../mixins/setSelectedOperator';
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedOperator: null,
      selected: {
        operator: null,
        value: null,
      },
      operators: [
        { name: 'includes', operator: '$iLike', needValue: true },
        { name: 'excludes', operator: '$notILike', needValue: true },
      ],
    };
  },

  mixins: [setSelectedOperator],

  mounted() {
    this.selected = Object.assign({}, this.value);
    this.setSelectedOperator();

    this.$watch(
      'selectedOperator',
      selectedOperator => {
        this.$emit('input', {
          operator: selectedOperator.operator,
          value: selectedOperator.needValue ? this.selected.value : selectedOperator.value,
        });
      },
      { deep: true },
    );

    this.$watch(
      'selected',
      selected => {
        this.$emit('input', {
          operator: this.selectedOperator.operator,
          value: selected.value,
        });
      },
      { deep: true },
    );
  },
};
</script>
